<script setup lang="ts">
import { useLegacyHttpClient } from "@/composables/compat/useLegacyHttpClient"
import { useNavbarState } from "@/stores"
import type { Ref } from "vue"
import { ref } from "vue"

const http = useLegacyHttpClient()
const success: Ref<any> = ref(null)
const navbarState = useNavbarState()

const queryParams = new URLSearchParams(window.location.search)
if (queryParams.has("activate")) {
    try {
        await http.post("/registration/activate", {
            token: queryParams.get("activate"),
        })
        success.value = true
    } catch {
        success.value = false
    }
}
</script>

<template>
    <div class="card-body">
        <h5 class="card-title">
            {{ $t("@app:registration.activation.title") }}
        </h5>
        <div class="alert alert-success" v-if="success">
            {{ $t("@app:registration.activation.success") }}
        </div>
        <div class="alert alert-danger" v-if="success === false">
            {{ $t("@app:registration.activation.failed") }}
        </div>
        <div class="mt-4 text-right">
            <button class="btn btn-primary" @click="navbarState.openCard(null)">OK</button>
        </div>
    </div>
</template>
